import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import * as Urql from '@/utils/urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type PinnedItemsQueryVariables = Types.Exact<{
  filters?: Types.InputMaybe<Types.BookmarkFilters>;
  sort?: Types.InputMaybe<Array<Types.SortType> | Types.SortType>;
}>;


export type PinnedItemsQuery = { paginatedBookmarks?: { edges?: Array<{ node: { id: string, name?: string | null, type?: Types.BookmarkTypeEnum | null, entityId: string, entityType: Types.BookmarkEntityTypeEnum, parentEntityId?: string | null, parentEntityType?: Types.BookmarkEntityTypeEnum | null, parentEntity?: { id: string, name: string, type: Types.ResourceTypeEnum } | {} | null, entity?: { id: string, name: string, type: Types.ResourceTypeEnum } | { id: string, name: string, type: Types.ResourceTypeEnum } | { id: string, name: string, type: Types.ResourceTypeEnum } | { id: string, name: string, type: Types.ResourceTypeEnum } | {} | null } }> | null } | null };


export const PinnedItemsDocument = /*#__PURE__*/ gql`
    query pinnedItems($filters: BookmarkFilters, $sort: [SortType!]) {
  paginatedBookmarks(filters: $filters, sort: $sort) {
    edges {
      node {
        id
        name
        type
        entityId
        entityType
        parentEntityId
        parentEntityType
        parentEntity {
          ... on CourseContentType {
            id
            name
            type
          }
        }
        entity {
          ... on CourseContentType {
            id
            name
            type
          }
          ... on ArticleContentType {
            id
            name
            type
          }
          ... on PathContentType {
            id
            name
            type
          }
          ... on QuizContentType {
            id
            name
            type
          }
        }
      }
    }
  }
}
    `;

export function usePinnedItemsQuery(options?: Omit<Urql.UseQueryArgs<PinnedItemsQueryVariables>, 'query'>) {
  return Urql.useQuery<PinnedItemsQuery, PinnedItemsQueryVariables>({ query: PinnedItemsDocument, ...options });
};